import toast from 'react-hot-toast';
import { useState } from 'react';
import { Modal, Button, Loader } from '../../../../UiKit';
import { EmptyState } from '../../../commons';
import { InvalidSearchImg } from '../../../../images/images';
import { MultiMedia } from '../../../../UiKit/multimedia/multimedia';
import { useQueryCall } from '../../../../api/react-client';
import { lifelineEndPoints } from '../../../../api/end-points';
import { useSelector } from 'react-redux';

const RIDER_APP = 'rider_app';

export function RiderComplaintImages({ orderId, userId }) {
  const [isVisible, setIsVisible] = useState(false);
  const isNewUI = useSelector((state) => state.ordersState?.isNewUI);

  if (!orderId && !userId) return null;

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
      <p
        className='tw-text-300 tw-font-medium tw-text-base-green tw-cursor-pointer tw-leading-none'
        onClick={() => setIsVisible(true)}
      >
        {isNewUI ? 'Rider-clicked Images' : 'View Rider Complaint Images'}
      </p>
      {isVisible && (
        <RiderComplaintImagesModal
          isVisible={isVisible}
          handleClose={() => setIsVisible(false)}
          orderId={orderId}
          userId={userId}
        />
      )}
    </>
  );
}

function RiderComplaintImagesModal({
  orderId,
  userId,
  isVisible,
  handleClose,
}) {
  const [offset, setOffset] = useState(0);

  const queryKey = [
    'lifeline_apis',
    'chat_media',
    'get_images',
    orderId,
    userId,
    offset,
    RIDER_APP,
  ];

  const getOrderIssueImgsEndPoint = `${lifelineEndPoints?.GET_CHAT_MEDIA}?order_id=${orderId}&customer_id=${userId}&offset=${offset}&type=${RIDER_APP}`;

  const { data, isLoading } = useQueryCall(
    { keepPreviousData: true },
    getOrderIssueImgsEndPoint,
    queryKey,
  );

  let mediaList = Array.isArray(data?.media_data)
    ? data?.media_data?.map((img) => ({
        src: img?.media_url,
        type: img?.media_type,
        upload_method: img?.upload_method,
      }))
    : [];

  return (
    <Modal
      isMaxContent
      isVisible={isVisible}
      type='large'
      title='View Rider Images/Videos'
      handleClose={handleClose}
      component={
        isLoading ? (
          <Loader />
        ) : data?.isError ? (
          <EmptyState
            img={InvalidSearchImg}
            heading={data?.message || 'Something went wrong'}
          />
        ) : (
          <>
            {mediaList?.length === 0 && (
              <EmptyState
                img={InvalidSearchImg}
                heading='Rider has not submitted any images'
              />
            )}

            <MultiMedia
              images={mediaList}
              mediaStyle={{
                display: 'flex',
                justifyContent: 'center',
              }}
              title='Rider Images/Videos'
            />

            {mediaList?.length && (data?.has_more || offset > 0) ? (
              <div
                css={`
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  gap: 1rem;
                `}
                className='tw-mt-[2rem]'
              >
                <Button
                  outline
                  disabled={isLoading}
                  onClick={() => {
                    if (offset === 0)
                      return toast.error('You are already at the end');
                    if (offset < 5) {
                      setOffset(0);
                    } else {
                      setOffset((o) => o - 5);
                    }
                  }}
                  title={'back'}
                />
                <div>
                  {offset} - {offset + 5}
                </div>
                <Button
                  outline
                  disabled={isLoading}
                  onClick={() => {
                    if (data.has_more) {
                      setOffset((o) => o + 5);
                    } else {
                      toast.error('No more images to show');
                    }
                  }}
                  title={'next'}
                />
              </div>
            ) : null}
          </>
        )
      }
    />
  );
}
